export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите наименование ', trigger: 'blur' },
    ],
    percent: [
        { required: true, message: 'Пожалуйста, введите процент ', trigger: 'blur' },
    ],
};
